<template>
  <b-select
    :disabled="ComputedDisabled"
    :required="required"
    :value="value"
    expanded
    placeholder="Select a School"
    @input="onInput">
    <option v-for="tenant in options" :key="tenant.id" :value="tenant.id">
      {{ tenant.school_name }}
    </option>
  </b-select>
</template>

<script>
  export default {
    name: "SelectTenant",
    components: {},
    data() {
      return {};
    },
    props: {
      value: Number,
      required: {
        type: Boolean,
        default() {
          return false;
        },
      },
      forceDefault: {
        type: Boolean,
        default() {
          return false;
        },
      },
      disabled: {
        type: Boolean,
        default() {
          return false;
        },
      },
      options: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    methods: {
      onInput(e) {
        this.$emit("input", e);
      },
    },
    computed: {
      ComputedDisabled() {
        if (this.options.length === 0) {
          return true;
        } else {
          return this.disabled;
        }
      },
    },
  };
</script>
